import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//新 billMonitor进销存报表
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}